// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:19+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            63a0b729648db05c21789f0753a8f51d
//    Signature:      eyJpdiI6IjNya3BGTnRRdmgrNVh4MjFwdkF3OHc9PSIsInZhbHVlIjoic1R3YlZGVWQwdXFJUEJXY2xCRTN2UmtQWE1hdmNvTit4aFNKbWpxeG05RFVYZkFUZGJhYWd4M0xOR3RCZ2pZMTU3bVNyVTYyMkV4NG5NQ1RueUVTdEFkQlVtUnhKc2RFWUFzaWZlaHFTY3BCZGdkTGd1UHBLcGJxZkFQS2F2a1hyN3RDV3djRFEyakpJajVYeHlZbVwvdVJCRnE3XC9YS2ZQUmdnN3pSZXdaR0cyWHFrK3o1ejM2eFBrYzJxTTI2VWFUb0laNVpFcGJkZ2lyUmxqTkdmcTgyYVdJa29zOW83UWpVUmFydG5cLzFTK3NQUGlFWVwvUklQY2NCYVoycEZnYVpzY2dIYW56Y09cL25Vc1doSUx2T3ZwXC9aTGZOVk9HV0ZKcEdtN0d3TEkxSmZ2SDFzeklXWHlhV29NaEdEXC9cL2lwZ0N2ZzRKYWozTHVlMUw5S001eURRVG1pSWtZdnp1Y1U2SDBsTnoyMGRlQXUrTENlUFB5UVVXRThQXC9URHVESTFiQUY4TGpDb2JHRHV2bXNHajQ5ZDdmZz09IiwibWFjIjoiNWJkNDBiZTI4YjM4ODhkNGUwNzcyOThlNDQ2MTQ1ODY0MWNhOWFjMGMwYWFjYWQ3ZDFmMzhiZjQyYWE1NGY1NyJ9
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
